<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="copyright-page" id="cip">
<p class="crtf"><span aria-label=" Page iv. " class="page" epub:type="pagebreak" id="piv" role="doc-pagebreak"></span>Open access edition funded by the National Endowment for the Humanities.</p>
<p class="crtf"><img alt="" height="35" src="images/logo-OA-by-nc-nd.jpg" width="100"/></p>
<p class="crt">This work is being made available under the Creative Commons Attribution-Non-Commercial-No Derivatives 4.0 International License (CC BY-NC-ND 4.0). To view a copy of this license, visit <a class="url" href="https://creativecommons.org/licenses/by-nc-nd/4.0/" target="_blank">https://creativecommons.org/licenses/by-nc-nd/4.0/</a></p>
<p class="crtf">The University of Chicago Press, Chicago 60637</p>
<p class="crt">The University of Chicago Press, Ltd., London</p>
<p class="crt">© 2019 by The University of Chicago</p>
<p class="crt">Published 2019</p>
<p class="crt">Printed in the United States of America</p>
<p class="crtf">28 27 26 25 24 23 22 21 20 19    1 2 3 4 5</p>
<p class="crtf"><span class="sm">ISBN</span>-13: 978-0-226-63132-5 (cloth)</p>
<p class="crt"><span class="sm">ISBN</span>-13: 978-0-226-63146-2 (e-book)</p>
<p class="crt"><span class="sm">DOI</span>: <a class="url" href="https://doi.org/10.7208/chicago/9780226631462.001.0001" target="_blank">https://doi.org/10.7208/chicago/9780226631462.001.0001</a></p>
<p class="cipf">Library of Congress Cataloging-in-Publication Data</p>
<p class="cipf">Names: Fischer, Marilyn, author.</p>
<p class="cip">Title: Jane Addams’s evolutionary theorizing : constructing “Democracy and social ethics” / Marilyn Fischer.</p>
<p class="cip">Description: Chicago ; London : The University of Chicago Press, 2019. | Includes bibliographical references and index.</p>
<p class="cip">Identifiers: <span class="sm">LCCN</span> 2018046935 | <span class="sm">ISBN</span> 9780226631325 (cloth : alk. paper) | <span class="sm">ISBN</span> 9780226631462 (e-book)</p>
<p class="cip">Subjects: <span class="sm">LCSH</span>: Addams, Jane, 1860–1935. | Addams, Jane, 1860–1935. Democracy and social ethics. | Social evolution. | Evolution—Moral and ethical aspects. | Democracy. | Social ethics. | Pragmatism.</p>
<p class="cip">Classification: <span class="sm">LCC</span> <span class="sm">HV</span>28.<span class="sm">A</span>35 <span class="sm">F</span>56 2019 | <span class="sm">DDC</span> 303.3/720973—dc23</p>
<p class="cip"><span class="sm">LC</span> record available at <a class="url" href="https://lccn.loc.gov/2018046935" target="_blank">https://lccn.loc.gov/2018046935</a></p>
<p class="crtf"><img alt="" height="12" src="images/infinity-symbol.jpg" width="12"/> This paper meets the requirements of <span class="sm">ANSI/NISO</span> <span class="sm">Z</span>39.48-1992 (Permanence of Paper).</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Fischer-OA-0004.vue?dee765be